import type { ReactNode } from 'react'
import SiteFooter from './SiteFooter'

type LegalPageLayoutProps = {
  children: ReactNode
  eyebrow: string
  title: string
  showUpdated?: boolean
  updated?: string
}

export default function LegalPageLayout({ children, eyebrow, title, showUpdated = true, updated = '11 de setembro de 2026' }: LegalPageLayoutProps) {
  return (
    <div className="legal-shell">
      <a className="skip-link" href="#conteudo">Pular para o conteúdo</a>
      <header className="site-header legal-header">
        <a className="brand" href="/" aria-label="Oficina IA: início">
          <img src="/assets/logo/symbol.svg" alt="" />
          <span>Oficina IA</span>
        </a>
        <a href="/">Voltar para a página inicial</a>
      </header>
      <main className="legal-page" id="conteudo" tabIndex={-1}>
        <p className="eyebrow"><span /> {eyebrow}</p>
        <h1>{title}</h1>
        {children}
        {showUpdated && <p className="legal-page__updated">Atualizado em {updated}.</p>}
      </main>
      <SiteFooter />
    </div>
  )
}
